module.exports = __webpack_public_path__ + "static/media/mobile_error_icon.c1ee68e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mobile_error_icon.svg
// module id = 1612
// module chunks = 0